import axios from "axios";
import {
  INTAKE_LIST_REQUEST,
  INTAKE_LIST_SUCCESS,
  INTAKE_LIST_FAIL,
} from "../constants/intakeConstants";
import { api2 } from "../core/api";

export const getintake = () => async (dispatch) => {
  try {
    dispatch({
      type: INTAKE_LIST_REQUEST,
    });

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const { data } = await api2.get("/preferredIntake", config);

    var dt = data.Result;

    if (typeof dt === "string") {
      dispatch({
        type: INTAKE_LIST_FAIL,
        payload: dt.replace("Error - ", ""),
      });
    } else {
      dispatch({
        type: INTAKE_LIST_SUCCESS,
        payload: dt,
      });
    }
  } catch (error) {
    dispatch({
      type: INTAKE_LIST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};
